export default __webpack_public_path__ + "static/media/arcade.0442abff.png";